import React from 'react';
import { Field } from 'react-form';
import PropTypes from 'prop-types';
import InfoButton from '../../InfoButton';
import CheckBoxBase from './CheckBoxBase';
import styles from './checkBox.scss';
import Img from '../../Img';

class CheckBox extends React.Component {
    constructor(props) {
        super(props);

        this.renderControlled = this.renderControlled.bind(this);
        this.renderFormField = this.renderFormField.bind(this);
    }

    renderControlled() {
        const {
            id,
            label,
            hiddenLabel,
            description,
            customLabel,
            customLabelClass,
            formGroupCssClass,
            hoverText,
            disabled,
            disableLabelSelect,
            checked,
            onChange,
            isFeedPreferenceModal,
            auth,
            'data-testid': dataTestId,
            ...rest
        } = this.props;
        const inputProps = {
            ...rest,
            id,
            type: 'checkbox',
            checked,
            disabled,
            onChange,
        };

        return (
            <div className={`form-group ${description && 'description'} ${styles.checkBox} ${formGroupCssClass}`} data-testid={dataTestId || undefined}>
                <label htmlFor={id} className={`${hiddenLabel ? 'sr-only' : ''}`}>
                    {label}
                    {hoverText && <InfoButton hoverText={hoverText} />}
                </label>
                {description && (<small>{description}</small>)}
                <CheckBoxBase
                    wrapperCssClass={'input-wrapper'}
                    inputProps={inputProps}
                    onChange={(checked, e) => {
                        if (disabled !== true && onChange) {
                            onChange(checked, e);
                        }
                    }}
                    customLabel={customLabel}
                    customLabelClass={customLabelClass}
                    checked={checked}
                    disabled={disabled}
                    data-testid={dataTestId}
                />
            </div>
        );
    }

    renderFormField() {
        const { field, auth, validate, additionalClassName, iconClassName } = this.props;
        const defaultValue = field === 'tennis'
            ? !!auth?.feedPreferences?.showTennisContent
            : !!auth?.feedPreferences?.showPickleballContent;

        return (
            <Field
                field={field}
                defaultValue={defaultValue}
                validate={validate}
            >
                {fieldApi => {
                    const { onChange, onBlur, id, label, hiddenLabel, description, customLabel, formGroupCssClass, hoverText, disabled, disableLabelSelect, onClick, isFeedPreferenceModal, auth, field, 'data-testid': dataTestId,
                    ...rest } = this.props;
                    const { value, error, warning, touched, setValue, setTouched } = fieldApi;
                    const inputProps = {
                        ...rest,
                        id,
                        type: 'checkbox',
                        checked: value || false,
                        disabled,
                        onChange: e => {
                            if (disabled !== true) {
                                setValue(e.target.checked);
                                if (onChange) {
                                    onChange(e.target.checked, e);
                                }
                            }
                        },
                        onBlur: e => {
                            setTouched();
                            if (onBlur) {
                                onBlur(e);
                            }
                        },
                    };

                    return (
                        <div className={`form-group ${(touched && error) && 'is-invalid'} ${description && 'description'} ${styles.checkBox} ${formGroupCssClass}`} data-testid={dataTestId || undefined}>
                            <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                                {label}
                                {hoverText && <InfoButton hoverText={hoverText} />}
                            </label>
                            {description && (<small>{description}</small>)}
                            <div className="input-wrapper">
                                <input {...inputProps} className={`${isFeedPreferenceModal ? styles.feedPreferenceInput : ''}`} data-testid={dataTestId && `${dataTestId}.input`} />
                                {!isFeedPreferenceModal && (
                                <div>
                                    <label>
                                        <div className={`${additionalClassName} ${styles.customCheckBox} checkbox-custom`}>
                                            <span
                                                className={`${iconClassName} ${styles.customCheckIcon} ${disabled ? styles.disabled : ''} ${value ? styles.checked : ''}`}
                                                onClick={(ev) => {
                                                    if (disabled !== true) {
                                                        if (onClick) {
                                                            onClick(ev, value);
                                                        } else {
                                                            setValue(!value);
                                                            // Set Value does not seem to trigger on change, manually calling
                                                            if (onChange) {
                                                                onChange(!value, ev);
                                                            }
                                                        }
                                                    }
                                                }}
                                                data-testid={dataTestId && `${dataTestId}.check-icon`}
                                            >
                                                {value && <Img src="/img/icons/checkmark-icon.svg" />}
                                            </span>
                                            <span
                                                className={`${styles.customCheckLabel} ${disabled ? styles.disabled : ''}`}
                                                onClick={(ev) => {
                                                    if (disableLabelSelect) {
                                                        // DO nothing
                                                    } else if (disabled !== true) {
                                                        if (onClick) {
                                                            onClick(ev, value);
                                                        } else {
                                                            setValue(!value);
                                                            // Set Value does not seem to trigger on change, manually calling
                                                            if (onChange) {
                                                                onChange(!value, ev);
                                                            }
                                                        }
                                                    }
                                                }}
                                                data-testid={dataTestId && `${dataTestId}.label`}
                                            >
                                                {customLabel}
                                            </span>
                                        </div>
                                    </label>
                                </div>
                                )}

                                {!!isFeedPreferenceModal && (
                                <label
                                    onClick={(ev) => {
                                        if (disabled !== true) {
                                            if (onClick) {
                                                onClick(ev, value);
                                                setValue(ev.target.checked);
                                            } else {
                                                setValue(!value);
                                                if (onChange) {
                                                    onChange(!value, ev);
                                                }
                                            }
                                        }
                                    }}
                                    className={`${styles.feedPreferenceLabel}`}
                                >
                                    <span className={`${styles.round} ${styles.slider} ${value ? styles.checkedradio : ''}`} data-testid={dataTestId && `${dataTestId}.slider`} />
                                </label>
                                  )}
                            </div>
                            {touched &&
                                ((error && <div className="invalid-feedback" data-testid={dataTestId && `${dataTestId}.error`}>{error}</div>) ||
                                (warning && <div className="warning-feedback" data-testid={dataTestId && `${dataTestId}.warning`}>{warning}</div>))}
                        </div>
                    );
                }}
            </Field>
        );
    }

    render() {
        const { controlled } = this.props;
        if (controlled) {
            return this.renderControlled();
        }
        return this.renderFormField();
    }
}

CheckBox.propTypes = {
    additionalClassName: PropTypes.string,
    iconClassName: PropTypes.string,
};

CheckBox.defaultProps = {
    additionalClassName: '',
    iconClassName: '',
};

export default CheckBox;
